// extracted by mini-css-extract-plugin
module.exports = {"tabs":"DiscoverTabs_tabs__liAbc","tab":"DiscoverTabs_tab__FbYGq"};